export default __webpack_public_path__ + "static/mine-free_cover-big_1-421beff5ba2944f66dc2fec708b7f774.png";